<template>
  <div class="page-content" style="min-height: 546px;">
    <div class="page-head-correios-index-usuario">
      <div class="page-title">
        <h1>Como encontrar informação Código API</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ">
        <div class="portlet light bordered">
          <div class="row text-justify">
            <div class="m-heading-1 border-green m-bordered">
              <p class="font-text">
                Os Correios adotaram um novo sistema de cálculo de fretes que necessitará de
                contrato com os Correios obrigatoriamente (caso ainda não possua <a href="https://meucorreios.correios.com.br/app/cadastro/pj/cadastro.php" target="_blank">clique aqui</a> para
                fazer seu cadastro). É fundamental atualizar
                as configurações em nossa plataforma para que seu frete continue sendo calculado
                normalmente.
                Nesse conteúdo vamos te mostrar onde você pode encontrar a informação do campo
                Código API.
              </p>
              <p class="font-text">
                Antes de tudo é preciso acessar o Correios Web Services, <a href="https://cws.correios.com.br/" target="_blank">clique
                  aqui</a> para ser direcionado
                  para a página. Após entrar na pagina será necessário fazer o login, clique na
                  informação entrar que destacamos na imagem abaixo.
                </p>
                <br>
                <figure>
                  <img class="w-full" src="../../../assets/images/helps/codigo-api/codigo api correios 1.png" alt="tela inicial do portal correios web service">
                </figure>
                <p class="font-text">
                  Depois de clicar em entrar insira suas credenciais juntamente com a senha e clique
                  novamente em entrar.
                </p>
                <figure>
                  <img class="w-full" src="../../../assets/images/helps/codigo-api/codigo api correios 2.png" alt="tela login do portal correios web service">
                </figure>
                <p class="font-text">
                  Após entrar, você se deparará com uma tela igual ao exemplo abaixo e deverá clicar em
                  gestão de acessos a API's.
                </p>
                <figure>
                  <img class="w-full" src="../../../assets/images/helps/codigo-api/codigo api correios 3.png" alt="tela home do portal correios web service">
                </figure>
                <p class="font-text">
                  Dentro da tela, você deverá novamente inserir as suas credenciais e clicar em regerar
                  código.
                </p>
                <figure>
                  <img class="w-full" src="../../../assets/images/helps/codigo-api/codigo api correios 4.png" alt="tela gestao de acesso api do portal correios web service">
                </figure>
                <p class="font-text">
                  Caso você já possua um código de acesso, o sistema exibirá a mensagem de confirmação
                  que mostramos abaixo e será necessário emitir um novo. Clique em "Sim" para
                  prosseguir.
                </p>
                <figure>
                  <img class="w-full" src="../../../assets/images/helps/codigo-api/codigo api correios 5.png" alt="tela gestao de acesso api gerar token do portal correios web service">
                </figure>
                <p class="font-text">
                  Caso você não possua um código de acesso ou tenha clicado em sim, o sistema exibirá
                  a mensagem contendo o token, esse é o dado que é preciso adicionar no nosso novo
                  campo. Agora basta copiar e colar lá na nossa tela de configurações.
                </p>
                <figure>
                  <img class="w-full" src="../../../assets/images/helps/codigo-api/codigo api correios 6.png" alt="tela gestao de acesso api token gerado do portal correios web service">
                </figure>
                <p class="font-text">
                  Prontinho! Agora você encontrou a informação que deve ser adicionada no novo campo
                  Código API das nossas configurações correios. Se você tiver alguma dúvida
                  quanto a esse
                  novo sistema de cálculo, por favor, não hesite em nos contatar. Estamos
                  sempre aqui para ajudá-lo.
                </p>
                <p class="font-text text-center">
                  Obrigado por usar a nossa app.
                </p>
                <p class="font-text text-center">
                  Atenciosamente,<br>
                  Gadol Apps.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
  export default {
    
  }
</script>
<style lang="">

</style>